<template>
  <a class="col btn" href="javascript:void(0)" @click="$emit('click')" :title="title">
    <icon-base :icon-color="'#1e88e5'">
      <inner-svg />
    </icon-base>

  </a>
</template>
<script>
const svg = {
  template: `<svg aria-hidden="true" data-prefix="fas" data-icon="redo" class="svg-inline--fa fa-redo fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M500.33 0h-47.41a12 12 0 00-12 12.57l4 82.76A247.42 247.42 0 00256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 00166.18-63.91 12 12 0 00.48-17.43l-34-34a12 12 0 00-16.38-.55A176 176 0 11402.1 157.8l-101.53-4.87a12 12 0 00-12.57 12v47.41a12 12 0 0012 12h200.33a12 12 0 0012-12V12a12 12 0 00-12-12z"/>
    </svg>`
};
import IconBase from '@/components/IconBase.vue';

export default {
  props: {
    title: {
      default: ''
    },
    extraClass:{
      required: false,
      default : null
    }
  },
  components: {
    'icon-base': IconBase,
    'inner-svg': svg
  }
};

</script>
<style lang="scss" scoped>

.refresh_holder_left{
  padding: 0px;
  height: 100%;
  vertical-align: middle;
  svg{
    height: 100%;
    vertical-align: middle;
    }
    }
</style>